"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockquoteElement = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("@jsonjoy.com/ui/lib/styles/context");
const BlockPlaceholder_1 = require("./BlockPlaceholder");
const indentation_1 = require("../../behavior/indentation");
const font_1 = require("../../behavior/font");
const css_1 = require("../../custom-style/css");
const util_1 = require("../../util");
const blockquoteClass = (0, nano_theme_1.rule)({
    pos: 'relative',
    mr: '18px 0',
    pd: '24px 18px',
    paddingInlineStart: '42px',
    fz: '1.05em',
    // lh: 1.9,
    borderStartStartRadius: 0,
    borderStartEndRadius: '16px',
    borderEndEndRadius: '16px',
    borderEndStartRadius: 0,
});
const BlockquoteElement = ({ attributes, children, element }) => {
    const styles = (0, context_1.useStyles)();
    const dynamicClass = (0, nano_theme_1.useRule)(({ g }) => ({
        bg: g(0, 0.015),
        borderInlineStart: `3px solid ${g(0.24)}`,
        trs: 'background 140ms ease, border-color 140ms ease',
        '&:hover': {
            bg: g(0, 0.035),
            borderInlineStartColor: g(0),
        },
    }));
    return (React.createElement("blockquote", { ...attributes, className: blockquoteClass + dynamicClass, style: {
            textAlign: element.align,
            marginInlineStart: (0, indentation_1.indentPadding)(element.indent) ?? 0,
            fontFamily: (0, font_1.fontFamilyOf)(element.font),
            color: (0, css_1.fgVar)(30, styles.g(0.3)),
        } },
        children,
        (0, util_1.isEmptyBlock)(element) && React.createElement(BlockPlaceholder_1.BlockPlaceholder, { element: element })));
};
exports.BlockquoteElement = BlockquoteElement;
